import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

interface StoryImageProps {
    src: string;
    alt?: string;
}

export default function StoryImageLoader({src, alt}: StoryImageProps) {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false); 
        const img = new Image();
        img.src = src;
        img.onload = () => setLoaded(true);
    }, [src]);

    if (!loaded) {
        return (
            <Box
                sx={{
                    width: {
                        xs: '100%',
                        sm: '95%',
                        md: '90%',
                        lg: '80%',
                        xl: '1208px',
                    },
                    height: { xs: '240px', sm: '320px', md: '440px', lg: '560px' },
                    backgroundColor: '#111',
                    borderRadius: '8px',
                    mb: 5,
                }}
            />
        );
    }

    return (
        <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
                display: 'block',
                position: 'relative',
                left: '50%',
                transform: 'translateX(-50%)',
                width: {
                    xs: '100%',
                    sm: '95%',
                    md: '90%',
                    lg: '80%',
                    xl: '1208px',
                },
                maxWidth: '100%',
                height: { xs: '240px', sm: '320px', md: '440px', lg: '560px' },
                objectFit: 'cover',
                borderRadius: '8px',
                mb: 5,
            }}
        />
    );
}